import { Suspense, ReactNode } from 'react';
import { Box, CssBaseline, Container, Typography } from '@mui/material';
import { Error, Loading, CheckForApplicationUpdate } from 'react-admin';
import { ErrorBoundary } from 'react-error-boundary';
import { useLocation } from 'react-router-dom';

import Header from './Header';
import HelpFab from '@/modules/help/HelpFab';

const isEstimatorRoute = (pathname: string) =>
    pathname === '/quotes/create' || /^\/quotes\/\d+$/.test(pathname);

const Layout = ({ children }: { children: ReactNode }) => {
    const { pathname } = useLocation();
    const fullWidth = isEstimatorRoute(pathname);

    return (
    <>
        <CssBaseline />
        <Header />
        <Container
            maxWidth={fullWidth ? false : undefined}
            sx={fullWidth ? undefined : { maxWidth: { xl: 1600 } }}
        >
            <main id="main-content">
                <ErrorBoundary FallbackComponent={Error}>
                    <Suspense fallback={<Loading />}>{children}</Suspense>
                </ErrorBoundary>
            </main>
        </Container>
        <Box
            component="footer"
            sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                px: 2,
                py: 1,
                color: 'text.secondary',
                position: 'fixed',
                bottom: 0,
                left: 0,
            }}
        >
            <Typography variant="caption" component="span">
                v{import.meta.env.VITE_APP_VERSION}
            </Typography>
        </Box>
        <HelpFab />
        <CheckForApplicationUpdate interval={30 * 1000} />
    </>
    );
};

export default Layout;
